import React from 'react'
import { TAG_CLICK_HELP_BUTTON } from '../../../store/analytics/analytics.actionTypes'
import TagActionLink from '../../genericComponents/TagActionLink'
import question from '../../genericComponents/assets/question.svg'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import s from './FooterContact.less'

export default function FooterContact(props) {
  return (
    <div className={props.className}>
      <TagActionLink
        type={TAG_CLICK_HELP_BUTTON}
        href="https://mappy.uservoice.com/"
        className={s.link}
        target="_blank"
        rel="nofollow noreferrer noopener"
      >
        <SVGIcon url={question} />
        <T id={'footer.needhelp'} />
      </TagActionLink>
    </div>
  )
}
